<template>
    <div class="w-full layout-timer-sounds-tab">
        <RedesignBaseForm
            ref="generalSettingsForm"
            class="space-y-10"
        >
            <RedesignVerticalFormItem
                v-for="parameter in timeParameters"
                :key="parameter.LayoutParameterName"
                :title="getLayoutConfigParameterTranslation(parameter.LayoutParameterName)"
                :description="getLayoutConfigParameterInfoTranslation(parameter.LayoutParameterName)"
                class="layout-timer-item"
            >
                <base-time-input
                    v-model="parameter.Value"
                    :min-value="0"
                    :step="1"
                    class="input-number"
                    max-width="200px"
                    color="primary"
                />
            </RedesignVerticalFormItem>
            <RedesignVerticalFormItem
                v-if="disableVisualAlertParameter"
                :title="getLayoutConfigParameterTranslation('DisableVisualAlertOnThreshold')"
                :description="getLayoutConfigParameterInfoTranslation('DisableVisualAlertOnThreshold')"
            >
                <RedesignSwitch
                    v-model="disableVisualAlertParameter.Value"
                    active-value="1"
                    inactive-value="0"
                />
            </RedesignVerticalFormItem>
            <template v-if="soundsParameters.length">
                <RedesignVerticalFormItem
                    v-for="parameter in soundsParameters"
                    :key="parameter.LayoutParameterName"
                    :title="getLayoutConfigParameterTranslation(parameter.LayoutParameterName)"
                    :description="getLayoutConfigParameterInfoTranslation(parameter.LayoutParameterName)"
                >
                    <SoundSelect
                        v-model="parameter.Value"
                        :placeholder="parameter.Value"
                        :options="allSoundList"
                    />
                </RedesignVerticalFormItem>
            </template>
        </RedesignBaseForm>
    </div>
</template>

<script setup lang="ts">
import RedesignBaseForm from '@/components/RedesignBaseComponents/Form/RedesignBaseForm.vue'
import RedesignVerticalFormItem from '@/components/RedesignBaseComponents/Form/RedesignVerticalFormItem.vue'
import RedesignSwitch from '@/components/RedesignBaseComponents/Inputs/RedesignSwitch.vue'
import { computed } from 'vue'
import { ILayoutItem } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'
import BaseTimeInput from '@/components/Common/BaseTimeInput.vue'
import { getLayoutConfigParameterInfoTranslation, getLayoutConfigParameterTranslation } from '@/helpers/translation'
import { DEFAULT_LAYOUT_TIMERS_SETTINGS, isLoginStatusSounds } from '@/enum/layout'
import { allSoundList } from '@/composables/globalData/useEntitiesData'
import SoundSelect from '@/components/Common/SoundSelect.vue'

const props = defineProps<{
    value: ILayoutItem
}>()
const emit = defineEmits<{
    (e: 'input', value: ILayoutItem): void
    (e: 'update:value', value: ILayoutItem): void
}>()

const layoutLocalModel = useVModel(props, 'value', emit, { eventName: 'input' })

const timeParameters = computed(() => {
    return (layoutLocalModel.value?.LayoutParametersList || []).filter((parameter) => DEFAULT_LAYOUT_TIMERS_SETTINGS.includes(parameter.LayoutParameterName))
})

const soundsParameters = computed(() => {
    return (layoutLocalModel.value?.LayoutParametersList || []).filter(
        (parameter) => parameter.ParameterTypeName === 'SingleSoundSelector' && !isLoginStatusSounds(parameter.LayoutParameterID)
    ) || []
})

const disableVisualAlertParameter = computed(() => {
    return (layoutLocalModel.value?.LayoutParametersList || []).find(
        (parameter) => parameter.LayoutParameterName === 'DisableVisualAlertOnThreshold'
    )
})

</script>

